export const ACTIONS = {
    CHANGE_PASSWORD: "change_password",
    SET_LOADING: "gm/set_loading",
    GET_USER_DETAILS: "gm/get_user_details",
    GET_BOOKING_OVERVIEW: "gm/booking_overview",



};
interface SetLoading {
    type: typeof ACTIONS.SET_LOADING;
    payload: boolean;
}

interface ChangePassword {
    type: typeof ACTIONS.CHANGE_PASSWORD;
    payload: Object;
}
interface GetUserDetails {
    type: typeof ACTIONS.GET_USER_DETAILS;
    payload: Object;
}
interface GetBookingOverview {
    type: typeof ACTIONS.GET_BOOKING_OVERVIEW;
    payload: Array<any>;
}

export type GenomTypes =
    | SetLoading
    | ChangePassword
    | GetUserDetails
    | GetBookingOverview

